// 共通の地図閲覧権限判定ロジック

// "YYYY-MM-DD"形式の文字列を日本時間としてパースする
const parseLocalDate = (dateStr: string): Date => {
  return new Date(`${dateStr}T00:00:00+09:00`);
};

export const determineMapServicePermission = ({
  appId,
  contractStartDate,
  trialStartDate,
  trialEndDate,
}: {
  appId: string | null;
  contractStartDate: string | null;
  trialStartDate: string | null;
  trialEndDate: string | null;
}): boolean => {
  if (!appId) return false;

  const now = new Date();
  now.setHours(0, 0, 0, 0);

  if (contractStartDate) {
    const contractStart = parseLocalDate(contractStartDate);
    if (contractStart <= now) {
      return true;
    }
  }

  if (trialStartDate && trialEndDate) {
    const trialStart = parseLocalDate(trialStartDate);
    const trialEnd = parseLocalDate(trialEndDate);
    // トライアル終了日時を丸1日有効とするため、終了日の時刻を当日の最終時刻に設定
    trialEnd.setHours(23, 59, 59, 999);

    if (now >= trialStart && now <= trialEnd) {
      return true;
    }
  }

  // NOTE: 再ログイン前のユーザーは従来のロジックで判定する
  if (!(!!contractStartDate || !!trialStartDate || !!trialEndDate)) {
    return true;
  }

  return false;
};
